import React from 'react';
import {Card, DonutChart} from './primitives';
import {ACCENT_LAB_TREND, DONUT_TRACK} from './chart-colors';

interface Props {
    participationRate: number;
    totalEligible: number;
    totalResults: number;
}

const ProgramParticipationCard: React.FC<Props> = ({participationRate, totalEligible, totalResults}) => {
    const displayPct = participationRate < 10 ? participationRate.toFixed(2) : Math.round(participationRate).toString();
    return (
        <div>
            <h3 className="mb-2 text-[24px] text-mld-muted-text">Program Participation</h3>
            <Card>
                <div className="flex h-[266px] items-stretch">
                    <div className="flex flex-1 flex-col items-center justify-center px-8">
                        <DonutChart pct={participationRate} size={170} strokeWidth={10} color={ACCENT_LAB_TREND} trackColor={DONUT_TRACK}>
                            <div className="text-[44px] font-bold text-mld-text-primary">{displayPct}%</div>
                        </DonutChart>
                        <div className="mt-3 -mb-2 text-[14px] text-mld-muted-text">Total Participation</div>
                    </div>
                    <div className="flex h-full flex-1 flex-col divide-y divide-mld-panel-border border-l border-mld-panel-border self-stretch">
                        <div className="flex flex-1 flex-col items-center justify-center">
                            <div className="text-[32px] font-bold leading-tight text-mld-text-primary">
                                {totalEligible.toLocaleString()}
                            </div>
                            <div className="text-[14px] text-mld-muted-text">Total Eligible</div>
                        </div>
                        <div className="flex flex-1 flex-col items-center justify-center">
                            <div className="text-[32px] font-bold leading-tight text-mld-text-primary">
                                {totalResults.toLocaleString()}
                            </div>
                            <div className="text-[14px] text-mld-muted-text">Total Results</div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default ProgramParticipationCard;
